import React from "react";

function InputFormField({ error, label, value, name, type = "text", required = true }) {
  return (
    <>
      <label className="form-label fw-medium mb-1">{label}</label>
      {error && <div className="form-error small mb-1">{error}</div>}
      <input
        type={type}
        className="form-control"
        name={name}
        id={name}
        required={required}
        defaultValue={value}
      />
    </>
  );
}

export default InputFormField;
